import { useState } from "react";
import { NumberCard } from "../../../components/cards/numberCard";
import { Pill } from "../../../components/pill";
import { TableComponent } from "../../../components/table";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import Dropdown from "../../../components/dropdown/dropdown";
import { Button } from "../../../components/buttons/button";
import { SearchInput } from "../../../components/inputs/searchInput";
import { useGetSalesInvitedOrganizersQuery } from "../../../redux/features/sales/sales.api";
import { QueryParams, SalesDashboardMetrics } from "../../../utils/types";
import { ProfileIcon } from "../../../components/cards/profilePic";
import { formatDate } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";

export const SalesOrganizers = ({
  fetchingMetrics,
  metrics,
  totalEvents,
}: {
  fetchingMetrics: boolean;
  metrics?: SalesDashboardMetrics;
  totalEvents: number;
}) => {
  const [year, setYear] = useState<string>("All Time");
  const navigate = useNavigate();

  const [query, setQuery] = useState<QueryParams>({
    page: 1,
    limit: 50,
  });

  const dropDownOptions = [
    {
      label: "All Time",
      value: 2025,
      onClick: () => {
        setYear("All Time");
      },
    },
  ];
  const { isFetching: fetchingOrganizers, data: organizersData } =
    useGetSalesInvitedOrganizersQuery(
      {
        ...query,
        search: query.search === "" ? undefined : query.search,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    );

  return (
    <div className="mt-3 flex flex-col gap-3">
      {/* <div className="flex w-full flex-col items-start justify-between gap-2.5 rounded-xl border-[2px] border-referral-border bg-referral p-3 shadow-referral-shadow lg:flex-row lg:items-center">
        <p className="w-full text-base font-bold text-grey-900">
          Start earning with your referral link ⚡️
        </p>
        <div className="flex w-full max-w-[480px] items-center justify-between gap-2.5 rounded-xl border-[2px] border-referral-border bg-white/25 p-3">
          <div className="flex items-center gap-2.5">
            <Icon
              svg="globe"
              height={20}
              width={20}
              className="text-grey-900"
            />
            <p className="flex-shrink-0 text-base font-bold text-grey-900">
              {`app.usetikket.com/signup?ref=${metrics?.data?.referralId}`}
            </p>
          </div>
          <CopyButton
            value={`app.usetikket.com/signup?ref=${metrics?.data?.referralId}`}
            className="text-sm font-bold text-grey-950"
          />
        </div>
      </div> */}
      <main className="flex flex-col gap-[3px]">
        <BgWrapper className="relative flex w-full flex-col">
          <div className="flex flex-col items-center gap-2.5 md:flex-row">
            <NumberCard
              value={metrics?.data?.totalOrganizersInvited ?? 0}
              text="Organizers Invited"
              isCurrency={false}
              loading={fetchingMetrics}
              titleFirst
            />
            <NumberCard
              value={totalEvents}
              text="Total Events "
              isCurrency={false}
              loading={fetchingMetrics}
              titleFirst
            />
            <NumberCard
              value={metrics?.data.totalTicketsSold ?? 0}
              text="Total Tickets Sold "
              isCurrency={false}
              loading={fetchingMetrics}
              titleFirst
            />
          </div>
        </BgWrapper>
        <BgWrapper>
          <div className="mb-3 flex w-full flex-col items-center justify-between md:flex-row">
            <SearchInput
              searchFunction={(value) => {
                setQuery({
                  ...query,
                  search: value,
                  page: 1,
                });
              }}
              placeholder="Search"
              className="md:!max-w-[300px]"
            />
            <Dropdown
              menuItems={dropDownOptions.map((option) => {
                return {
                  name: (
                    <p className="soft-shrink flex items-center gap-2 !rounded-md !bg-white p-3 text-left !text-sm !font-bold !text-grey-950">
                      {option.label}
                    </p>
                  ),
                  onClick: option.onClick,
                };
              })}
              className=""
              menuClassName="!gap-1 !border-0 !bg-grey-50 !p-1 !w-[200px]"
              menuItemsClassName="border-none !text-base !bg-transparent !p-0"
              position="bottom end"
            >
              <Button
                text={year}
                icon="caret-down"
                type="button"
                iconFirst={false}
                variation="styled-grey"
                iconClassName={"mb-1"}
                className="max-w-fit"
              />
            </Dropdown>
          </div>
          <TableComponent
            headers={[]}
            rows={
              organizersData?.data?.data?.map((organizer, idx) => {
                return {
                  id: idx,
                  items: [
                    <div
                      className={`flex w-full flex-1 flex-col justify-between gap-2 md:flex-row md:items-center`}
                    >
                      <div className="flex items-center gap-2">
                        <ProfileIcon dimension={33} className="!p-2" />
                        <div className="flex items-center gap-[2px]">
                          <p className="text-sm font-bold text-grey-900">
                            {organizer.name}
                          </p>
                          <p className="text-sm text-grey-600">
                            ∙ {organizer.email}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Pill
                          text={`${organizer?.status === "active" ? "ACTIVE" : "NO EVENT"}`}
                          variation={`${organizer?.status === "active" ? "green" : "grey"}`}
                        />
                        <p className="text-sm text-grey-600">
                          Joined on {formatDate(organizer?.dateJoined)}
                        </p>
                      </div>
                    </div>,
                  ],
                };
              }) ?? []
            }
            loadingRows={query.limit}
            isLoading={fetchingOrganizers}
            isRowClickable={true}
            onRowClick={(idx) => {
              const organizerId = organizersData?.data?.data?.[idx]?._id;
              if (organizerId) {
                navigate(`/dashboard/organizer/${organizerId}`);
              }
            }}
            isTableEmpty={[0, undefined].includes(
              organizersData?.data?.data?.length,
            )}
            emptyTitle="No Organizers Invited"
            emptySubTitle="Share the referral link with event organizers to get started!"
            emptyImage="/assets/images/guest-glass.png"
            isPaginated
            currentPage={query.page ?? 1}
            totalCount={organizersData?.data?.totalCount ?? 0}
            itemsPerPage={query.limit!}
            pageRangeDisplayed={3}
            onPageChange={(page) => {
              setQuery({
                ...query,
                page: page,
              });
            }}
            className=""
          />
        </BgWrapper>
      </main>
    </div>
  );
};
